import React from 'react'
import classes from './Body.module.css'

export default function Body({ children }) {
    return <div className={classes.wrapper}>{children}</div>
}
